import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { FeedbackDialog } from "@/components/feedback/FeedbackDialog";

const Ctx = createContext({ openFeedback: () => {}, closeFeedback: () => {} });

export const FeedbackProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, preset: {} });
  const openFeedback = useCallback((preset = {}) => setState({ open: true, preset }), []);
  const closeFeedback = useCallback(() => setState((s) => ({ ...s, open: false })), []);
  const value = useMemo(() => ({ openFeedback, closeFeedback }), [openFeedback, closeFeedback]);
  return (
    <Ctx.Provider value={value}>
      {children}
      <FeedbackDialog open={state.open} preset={state.preset} onClose={closeFeedback} />
    </Ctx.Provider>
  );
};

export const useFeedback = () => useContext(Ctx);
